import _ from 'underscore';
import { CWBaseModel } from 'src/core/models/cwBase.model';

/**
 * Model for an activite in treetypegreid table
 */
export class CWAbsenceModel extends CWBaseModel {
  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(attributes)) {
      options = attributes;
    }
    options = options || {};
    super(attributes, options);
  }

  defaults(): { [key: string]: any } {
    return {
      "code": "",
      "absence": "",
      "libelle": "",
      "datedeb": "",
      "unitedeb": null,
      "heuredeb": null,
      "datefin": "",
      "unitefin": null,
      "heurefin": null,
      "duree": null,
      "etat": null
    }
  }
}
